import React, { useState } from 'react';
import { Modal } from '@gerdau/hefesto';
import CountdownTimer from '../CountdownTimer';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { sendTagging } from '../../../store/ducks/tagging/actions';

interface ContinueSessionProps {
  onCancelClick: () => void;
  onContinueClick: () => void;
  loading: boolean;
}

const ModalContinueSession: React.FC<ContinueSessionProps> = ({
  onCancelClick,
  onContinueClick,
  loading
}) => {
  const [stopTimer, setStopTimer] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();

  const handleContinueClick = () => {
    dispatch(
      sendTagging({
        event: 'continuar_sessao',
        screenName: location.pathname,
        ecommerce: {
          sessionStatus: 'prestres_a_expirar'
        }
      })
    );
    setStopTimer(true);
    onContinueClick();
  };

  const getTime = (time: number) => {
    if (time <= 0) {
      onCancelClick();
    }
  };

  return (
    <div style={{ zIndex: 9999, position: 'absolute' }}>
      <Modal
        buttons={{
          left: {
            children: 'Encerrar a sessão',
            name: 'end-session',
            onClick: onCancelClick,
            type: 'button',
            variant: 'secondary',
            loading
          },
          right: {
            children: 'Continuar a sessão',
            name: 'continue-session',
            onClick: handleContinueClick,
            type: 'button',
            variant: 'primary',
            loading
          }
        }}
        modalSize="sm"
        title="Deseja continuar a sessão?"
      >
        <span>
          Por segurança, sua sessão será encerrada em breve devido à
          inatividade. Deseja continuar a sessão?
        </span>
        <CountdownTimer showTime={getTime} timerHasStopped={stopTimer} />
      </Modal>
    </div>
  );
};

export default ModalContinueSession;
